import type {
  IncidentV2SortField,
  SortOrder,
} from '@elementary/common-ui/services/gql/types';
import { INCIDENT_COLUMN_TO_SORT_FIELD } from '../constants';

export type IncidentSortVariable = {
  field: IncidentV2SortField;
  direction: SortOrder;
};

// Columns whose "ascending" arrow should show the highest-ranked value first
// (status rank is Resolved < Acknowledged < Open, but users expect Open on top).
const INVERTED_SORT_COLUMNS = new Set(['status']);

export const parseIncidentSortParam = (
  raw: string | null,
): IncidentSortVariable | undefined => {
  if (!raw) return undefined;
  try {
    const { id, direction } = JSON.parse(raw) as {
      id?: string;
      direction?: string;
    };
    const field = id ? INCIDENT_COLUMN_TO_SORT_FIELD[id] : undefined;
    if (!field || !id) return undefined;
    const isDesc = direction === 'desc';
    const inverted = INVERTED_SORT_COLUMNS.has(id);
    return {
      field,
      direction: isDesc !== inverted ? 'DESC' : 'ASC',
    };
  } catch {
    return undefined;
  }
};
